import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, RoleDTO} from '@sollapay/types';

export const rolesApi = {
  fetchRoles: async (client: HttpClient): Promise<ApiResponse<RoleDTO[]>> =>
    client.get<ApiResponse<RoleDTO[]>>('/roles')
};
